export default __webpack_public_path__ + "static/media/road4.9ad6988f.png";